export default __webpack_public_path__ + "static/media/tbm-asset-plank-02.5121692e.svg";